import { ChatConfig, MessageType } from '../../common/components/Chat/Chat.types';
import { DesignGenerationType } from '../DesignGenerator.types';
import { DesignTemplateData } from './DesignAI.types';
import { DesignAICategories } from './DesignAIContext';

/**
 * SuggestionMessage Component
 */
const sampleInfographicTopics = [
  'Tips to work from home efficiently',
  'Impacts, causes, and solutions of climate change',
  'Fun facts about plants',
];

const samplePosterTopics = [
  'New Years Eve Party on Dec 31 at 8pm',
  'Yard Sale next weekend',
  'Lunch and Learn on Wednesday',
];

export const categoryExampleTopicsMap: { [key in DesignAICategories]: string[] } = {
  [DesignAICategories.Infographics]: sampleInfographicTopics,
  [DesignAICategories.Charts]: sampleInfographicTopics,
  [DesignAICategories.Posters]: samplePosterTopics,
};

/**
 * DesignMessage Component
 */
const GENERATING_MESSAGE_INFOGRAPHIC = `
Ok, I am creating your infographic now...
Just so you know, I may occasionally generate incorrect information.
Also, I can't generate specialized widgets like timelines, charts, or maps.
After I create your infographic you can ask me to generate another but I'm not able to make adjustments to this one.
This won't take much longer. It takes time to generate each infographic because every design is unique.
Adding the finishing touches
`.trim();

const GENERATING_MESSAGE_POSTER = `
I am creating your design now...
Just so you know, I may occasionally generate incorrect information.
Adding the finishing touches
`.trim();

export const categoryGenMessageMap = {
  [DesignAICategories.Infographics]: GENERATING_MESSAGE_INFOGRAPHIC,
  [DesignAICategories.Charts]: GENERATING_MESSAGE_INFOGRAPHIC,
  [DesignAICategories.Posters]: GENERATING_MESSAGE_POSTER,
};

const TYPE_SPEED = 60;
const DELAY_PER_LINE = 1000;
const LOADING_DOT_TYPE_SPEED = 1000;

/**
 * Sample Data
 */
export const BASE_INFOGRAPH_TEMPLATE_ID_LIST: DesignTemplateData[] = [
  {
    e2DesignId: 'PmTmrDkEzhCVJOiaTV4LhmPn0P1H',
    e2DesignTitle: 'The Future of Cloud Computing',
    e1TemplateId: '5882396d-434e-4ea0-999f-356e204907cb',
  },
  {
    e2DesignId: 'dwInvUOYO2AeGPbrUSevzG1CB7cN',
    e2DesignTitle: '5 Cool Android Phone Apps',
    e1TemplateId: '288c6c38-b12a-4033-a4d2-09cbca45b238',
  },
  {
    e2DesignId: 'ZDqiqAWiEtIGpy6DYwnm2cCP9RVL',
    e2DesignTitle: 'Your Healthy Fitness Journey',
    e1TemplateId: 'ff0b8937-7733-4100-b549-0cf73a7ed4ca',
  },
  {
    e2DesignId: 'G514UBHW7fsDnxtZTEEd4IK2RE6y',
    e2DesignTitle: 'Diversity and Inclusion Terminology Infographic',
    e1TemplateId: 'dbc47165-dee4-478f-a0b9-313a54a533',
  },
  {
    e2DesignId: 'uxzsM4E3oP9rVVBQH8J5M1OboQcZ',
    e2DesignTitle: 'Internal Recruitment Methods Infographic',
    e1TemplateId: '0fbcf47e-1f8e-4786-81fd-4ecb54be280c',
  },
  {
    e2DesignId: 'U2lA7BK5XJGn0rKzb69XPVvTPiSO',
    e2DesignTitle: 'TYPES OF CHEMICAL REACTIONS',
    e1TemplateId: 'a9a003c4-0892-4282-89ad-7447f4345dea',
  },
  {
    e2DesignId: '06v2p74MazmO3yZsBGLNvSC4GEuS',
    e2DesignTitle: '4 Mind-Blowing  Science Facts',
    e1TemplateId: 'f7764a52-3dba-4e98-9e9b-b2c37680879b',
  },
  {
    e2DesignId: 'aC5RZNT0h7xhUawK7vcpEpqNdYsa',
    e2DesignTitle: 'Online Social Event Planning Infographic',
    e1TemplateId: '421fab76-b106-465b-8bfe-37a62f345b7b',
  },
  {
    e2DesignId: 'E9seikE5pLXcW0KlpqbR72SUSb9W',
    e2DesignTitle: 'EVERYTHING YOU NEED TO KNOW  ABOUT STOCKS',
    e1TemplateId: 'a87fc328-d954-49f3-9877-b81857aad8f4',
  },
  {
    e2DesignId: 'G5ao22ffzRNjoQNE5AH4NnK4j16I',
    e2DesignTitle: 'Employee Change Style Indicator Spectrum',
    e1TemplateId: '30770961-3e54-4c8f-826d-9db79f6a91c3',
  },
  {
    e2DesignId: 'MPeEtB6HkqKCtKoormYpHvp2xZFI',
    e2DesignTitle: 'Facebook Infographic Template',
    e1TemplateId: 'e3860998-a6ec-4bef-9a00-3e0abb3a15ad',
  },
  {
    e2DesignId: 'SJ81jprcIWtW98dIG8AFMlkohD1M',
    e2DesignTitle: 'Free Authoring Tools',
    e1TemplateId: '09feb17a-f6da-4c38-8b73-adc911cb3369',
  },
  {
    e2DesignId: 'GNiXzwRWIqfTLGhDSb9Orj8Mm3GZ',
    e2DesignTitle: 'How Can Coaches Assign Points to Goals and Tasks in Training Tasks',
    e1TemplateId: '8ea22839-76c3-44c7-a271-219bfaf24ba8',
  },
  {
    e2DesignId: 'u9tIbIlWFOUmFDYFgMvs1DGngnTm',
    e2DesignTitle: 'Vintage Project Management Plan Infographic',
    e1TemplateId: 'e967931a-986b-47e6-ac47-e2f06a3a1510',
  },
  {
    e2DesignId: 'Dl0tTTTTb4fPTIFa4Tzp7wnz2Sn8',
    e2DesignTitle: 'Computer Aided Design List Infographic',
    e1TemplateId: 'ec7e2c79-fac1-4538-88fc-f8d301c20031',
  },
  {
    e2DesignId: '5LfgvSID837T8IAA8LqccDtqWXr9',
    e2DesignTitle: '7 Unique Facts About Animals',
    e1TemplateId: 'c1f99977-1766-4d3b-824f-e2d584f54beb',
  },
  {
    e2DesignId: 'lRjkv9MKwOJwO29TNkQfSUa5lM0c',
    e2DesignTitle: 'Tree Infographic Template',
    e1TemplateId: '32e1f8b4-8da3-4b22-87ad-c49919066bb5',
  },
  {
    e2DesignId: 'pmGN2NqWENHd2FK1uKnRC13cUIM3',
    e2DesignTitle: 'A guide to sustainable eating: how to make eco-friendly food choices',
    e1TemplateId: '49e9461f-9948-410c-b0d3-881c8d466e8a',
  },
  {
    e2DesignId: '8Gymrv9GBwFBSZdRXZjltHCw7Dr9',
    e2DesignTitle: 'The Science of Flavor: Exploring the Chemistry Behind Our Favorite Tastes',
    e1TemplateId: '8d555ad1-398d-4da2-858c-7e8c8636071c',
  },
  {
    e2DesignTitle: 'The 5 Love Languages and What they Mean',
    e2DesignId: 'SZDEU4IM5IzaohV3HnnvwwbEeAJO',
    e1TemplateId: '03f1e681-a997-4cec-8417-a7c6055aab19',
  },
  {
    e2DesignTitle: 'Qualities Of A Good Friend',
    e2DesignId: 'Rie5MThf6MVLsgZT2JMlB4z93Vjk',
    e1TemplateId: 'c855ac8f-9511-44e8-8dd1-85dec3c7a5cf',
  },
  {
    e2DesignTitle: 'microlearning infographic',
    e2DesignId: 'rqbeh0jXwWjzsMBSxn7Irswq8eVP',
    e1TemplateId: 'd5d2db22-eb9d-4eb7-a1c4-1495700863f7',
  },
  {
    e2DesignTitle: 'client project timeline',
    e2DesignId: 'cBEe1rDyNLn8cLdbZfXvaQ1whvZl',
    e1TemplateId: 'f7fb5355-b0ee-4b3b-ac8a-eb545d233a15',
  },
  {
    e2DesignTitle: '4 reasons why instagram matters for business',
    e2DesignId: 'mpiTsm5rlhVUyPaBXckJOqXxYdQ1',
    e1TemplateId: 'b7803563-e8d2-4fdc-b8cc-638ba41a9abe',
  },
  {
    e2DesignTitle: 'do you have a crisis plan for your pet?',
    e2DesignId: '335qHXN0b6hPSGw92RltwL7fqSix',
    e1TemplateId: 'ad904ff0-cd24-4e40-8ca0-d9454cf76d0b',
  },
  {
    e2DesignTitle: 'Strategic Talent Acquisition Infographic',
    e2DesignId: 'LTx8bYeEe0ZWruJhgcRmgEAciDpk',
    e1TemplateId: 'f8a6250b-0cb6-4ff9-96fc-ad969073f0fe',
  },
  {
    e2DesignTitle: 'types of target markets',
    e2DesignId: 'uhu7QtTB4FwBzYhfaJIVu9uNSrnL',
    e1TemplateId: '9ca8b85b-00bc-433b-a603-6c829750067f',
  },
];

export const BASE_POSTER_TEMPLATE_ID_LIST: DesignTemplateData[] = [
  {
    e2DesignId: 'yQV2lz2U5jgOlqTIsqNRQOsyGl3A',
    e2DesignTitle: 'Colorful Art Exhibition Poster',
    e1TemplateId: '652f37e1-f130-44ba-92ee-114f85a71df6',
  },
  {
    e2DesignId: 'tP1tTcKGmYw47UXfeMok6hqfIZyF',
    e2DesignTitle: 'Lilac Auction Poster',
    e1TemplateId: 'a091ad4f-65dd-48eb-9e49-d4296c588978',
  },
  {
    e2DesignId: 'q5j4DgJiSmGCFeZ5aaiNvCffhugY',
    e2DesignTitle: 'Vibrant Community Picnic Event Poster',
    e1TemplateId: 'b310ae4a-ba57-4849-91ad-4fc482dbd209',
  },
  {
    e2DesignId: 'vQgjDXCQ4H51QLuMmkKfmu5vKg9A',
    e2DesignTitle: 'Colorful Free Tutoring Poster',
    e1TemplateId: 'a5db323e-c170-4b4f-8220-e91b987cee48',
  },
  {
    e2DesignId: 'VbOaNT9K1ziFKONqELTts9FwHuuG',
    e2DesignTitle: 'Green Dots Work Corporate Safety',
    e1TemplateId: '73d92c74-815a-4151-b198-f3301f0b18c6',
  },
  {
    e2DesignId: 'Dp3EpXUsWQemIsfgW9GFPJD2h15C',
    e2DesignTitle: 'Yellow Trivia Night Poster',
    e1TemplateId: 'fd6cff5b-7ce0-4d4b-b26b-856d922adf1f',
  },
  {
    e2DesignId: 'RMZAb88yefnwsq9ZGLHkILh6a2y1',
    e2DesignTitle: 'Prom Night Poster',
    e1TemplateId: '10b3979b-c650-4b5e-970a-6b579e047410',
  },
  {
    e2DesignId: 'VSNAExK9vWBuCHFU5zcjEXm3tD7l',
    e2DesignTitle: 'Bold Art Tutoring Poster',
    e1TemplateId: '59cdb262-e326-4541-9fee-047263961614',
  },
  {
    e2DesignId: 'Y0tnh8RpIcmrLI3JKrsP1xoZQvmH',
    e2DesignTitle: 'A4 Workplace Stress Management Event Poster',
    e1TemplateId: '990483e8-5da2-48bc-82e5-0a62b0f4149b',
  },
  {
    e2DesignId: 'RjgwzKXAke1qGgr8mHxUeoUpb593',
    e2DesignTitle: 'Color Block Tech Conference Poster',
    e1TemplateId: '2f6973bc-c457-4f0c-ab50-655efc959d72',
  },
  {
    e2DesignId: 'Nc7xVwDFY2t1p64zdOO9s2KZlivh',
    e2DesignTitle: 'Green Industrial Conference Poster',
    e1TemplateId: '8aab8d38-4c49-4a8c-bdf8-e4d95c7e51b4',
  },
  {
    e2DesignId: '1lxaJk4rBH2CQFT42OmRAwNDy44P',
    e2DesignTitle: 'Fun Student Conference Poster',
    e1TemplateId: 'fc24be98-06ac-4350-bd37-a9debdedfa85',
  },
  {
    e2DesignId: 'FP1STRPxfcCjx4jCbZKbDb0FRrrV',
    e2DesignTitle: 'Championship Boxing Match Event Poster',
    e1TemplateId: '4f3d016d-b2e8-4dcb-9df5-1452a3f9cfb4',
  },
  {
    e2DesignId: 'fwEKCJEQVPgbQMFbYcuVDWKqhg8u',
    e2DesignTitle: 'Blue Human Rights Posters',
    e1TemplateId: '3f85fe94-b218-4ab3-adfe-66facd1ce94b',
  },
  {
    e2DesignId: 'MobO6MZUgVfuYWnHcnJiT6PYib9E',
    e2DesignTitle: 'Bold Art Camp Event Poster',
    e1TemplateId: '2b4afb3b-26a0-449f-a15c-60070ae58ceb',
  },
];

export const BASE_CHART_TEMPLATE_ID_LIST: DesignTemplateData[] = [
  {
    e2DesignId: 'BqcNKQB56EyjXQ10foC4TxSBBM1V',
    e2DesignTitle: 'Company Expense Distribution Breakdown',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: '1Q463NxxO7uK8AfdxJZ1aFNfnjeu',
    e2DesignTitle: 'Single Chart Company Culture',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'bpUnyyJk0wco5eVk1fGPSMkuVxds',
    e2DesignTitle: 'Single Chart Thanksgiving Infographic',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'mHpYlWatBJc8eFI13QhdK9aX8EG7',
    e2DesignTitle: 'Specific Product Sales and Strategy Sales Report',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'zPk8uUN0YmqddB7IwvrKt5Hf4FXh',
    e2DesignTitle: 'Market Research Report',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'UtPk9lYlMzQZnt8K42dJV7UFhX3r',
    e2DesignTitle: 'Dark Purple And Orange Sales Performance Column Chart',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'jCnbbvILAwrFfnIgBwsaNFbzrQiU',
    e2DesignTitle: 'Statistical Report - V1',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'U05I0kpjCzOab9qrFQM6AAr9GJpK',
    e2DesignTitle: 'Statistical Report - V2',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'FJbkkK73HXbptP0G3TNNqngzPW5d',
    e2DesignTitle: 'Statistical Report - V3',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'CVE904jv0YbpQLQBI2dQ0zPAWTWT',
    e2DesignTitle: 'Statistical Report - V4',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
  {
    e2DesignId: 'mlEphyBaEDv81YB5co7ZhuRThUzN',
    e2DesignTitle: 'Statistical Report - V5',
    e1TemplateId: 'e60ed8c8-bfe3-4282-a13f-00a325749eda', // use blank template as placeholder, as it's not a public template
  },
];

export const DESIGN_AI_CHAT_CONFIG: ChatConfig = {
  [MessageType.BOT_GENERATING]: {
    typeSpeed: TYPE_SPEED,
    delayPerLine: DELAY_PER_LINE,
    loadingDotTypeSpeed: LOADING_DOT_TYPE_SPEED,
  },
};

export const categoryGenerationTypeMap = {
  [DesignAICategories.Infographics]: DesignGenerationType.Infograph,
  [DesignAICategories.Charts]: DesignGenerationType.Infograph,
  [DesignAICategories.Posters]: DesignGenerationType.Poster,
};

export const categoryTemplatesListMap = {
  [DesignAICategories.Infographics]: BASE_INFOGRAPH_TEMPLATE_ID_LIST,
  [DesignAICategories.Charts]: BASE_CHART_TEMPLATE_ID_LIST,
  [DesignAICategories.Posters]: BASE_POSTER_TEMPLATE_ID_LIST,
};
